<template>
  <div class="veda-article">
    <div class="web-box wrap">
      <div class="left-menu">
        <div
          class="menu-item"
          v-for="item in menuList"
          @click="selectMenu(item.id)"
          :key="item.id"
        >
          <div class="active-banner" v-if="item.id === selectMenuId"></div>
          <img :src="item.icon" />
          <span>{{ item.name }}</span>
        </div>
      </div>

      <div class="right-article">
        <div v-if="loading" class="loading">
          <a-spin />
        </div>

        <div
          class="article-item"
          @click="goToArticle(article.id)"
          v-for="article in articleList"
          :key="article.id"
        >
          <img :src="article.thumbnail" />
          <div class="article-text-wrap">
            <h3>{{ article.title }}</h3>
            <p class="text">{{ article.subtitle }}</p>
            <p>
              <span>{{ article.author }} | {{ article.date }}</span>
            </p>
          </div>
        </div>
        <div class="foot">
          <a-pagination style="float:right" v-model="page" :total="total" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      menuList: [],
      articleList: [],
      selectMenuId: -1,
      page: 1,
      total: 1,
      loading: false
    }
  },
  mounted () {
    this.getMenu()
  },
  methods: {
    async getMenu () {
      // const res = await axios.get(
      //   "http://www.vedamobi.com/allcustomer/api/menu_bar"
      // );
      // console.log(res);
      // if (res.data.code === 200) {
      this.menuList = [
        {
          id: '2',
          name: '行业资讯',
          icon:
            'https://h5.vedamobi.com/uploads/20191008/15704992865d9bead64b550.png'
        }
      ]
      this.selectMenu(this.menuList[0].id)
      // } else {
      //   this.$message.error(res.data.msg);
      // }
    },
    selectMenu (id) {
      this.page = 1
      this.selectMenuId = id
      this.getArticle()
      // this.loading = true
    },
    async getArticle () {
      // const res = await axios.get(
      //   "http://www.vedamobi.com/allcustomer/api/article_list",
      //   {
      //     params: {
      //       page: this.page,
      //       id: this.selectMenuId
      //     }
      //   }
      // );
      const data = {
        code: 200,
        msg: '查询成功',
        total: 4,
        total_page: 1,
        per_page: 10,
        page: 1,
        data: [
          {
            id: '5',
            title: '聚宝盆产品-助力企业拓展粉丝经济',
            thumbnail:
              'https://h5.vedamobi.com/uploads/20191224/15771537965e01750469b57.png',
            subtitle: '微博商业化产品营销',
            author: 'veda广告',
            date: '2021-12-24'
          },
          {
            id: '6',
            title: 'U微计划-社交+电商解决之道',
            thumbnail:
              'https://h5.vedamobi.com/uploads/20191224/15771568045e0180c4d2e1b.png',
            subtitle: '微博营销案例',
            author: 'veda广告',
            date: '2021-12-16'
          },
          {
            id: '4',
            title: '微博商业产品，助力品牌增长',
            thumbnail:
              'https://h5.vedamobi.com/uploads/20191120/15742178105dd4a8528a0bb.jpg',
            subtitle: '微博商业化产品营销',
            author: 'veda广告',
            date: '2021-11-20'
          },
          {
            id: '3',
            title: '互联网DSP广告系统架构及关键技术解析',
            thumbnail:
              'https://h5.vedamobi.com/uploads/20191008/15704994055d9beb4dafff9.jpg',
            subtitle: '根据付海军在【QCON高可用架构群】中的分享内容整理而成',
            author: 'VEDA广告',
            date: '2021-10-01'
          }
        ]
      }
      this.loading = false
      if (data && data.code === 200) {
        this.articleList = data.data
        this.total = data.total
      } else {
        this.$message.error(data.msg)
      }
    },
    goToArticle (id) {
      this.$router.push({
        path: 'articlePage',
        query: { id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.veda-article {
  .wrap {
    margin-top: 80px;
    display: flex;
    min-height: 600px;
  }
  .left-menu {
    flex: 1;
    max-width: 200px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    .menu-item {
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: rgb(136, 153, 242);
        background-color: #f1f1f1;
      }
      img {
        margin-left: 20px;
        width: 30px;
        height: 30px;
      }
      span {
        vertical-align: middle;
      }
      .active-banner {
        float: left;
        height: 50px;
        width: 4px;
        background-color: rgb(136, 153, 242);
      }
    }
  }
  .right-article {
    flex: 5;
    min-height: 100%;
    position: relative;
    padding-bottom: 40px;
    .foot {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
    }
  }
  .article-item {
    margin-bottom: 20px;
    margin-left: 20px;
    height: 160px;
    padding: 20px;
    background-color: #fff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    }
    img {
      float: left;
      width: 180px;
      height: 120px;
      border-radius: 3px;
    }
    h3 {
      font-size: 20px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .article-text-wrap {
      margin-left: 190px;
    }
    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
@media (max-width: 750px) {
  .veda-article {
    .wrap {
      flex-direction: column;
    }
    .left-menu {
      width: 100%;
      max-width: none;
    }
    .right-article {
      margin-top: 20px;
      width: 100%;
      .article-item {
        margin-left: 0;
        height: auto;
        padding: 10px;
        img {
          width: 100px;
          height: 75px;
        }
        .article-text-wrap {
          margin-left: 110px;
        }
      }
    }
  }
}
</style>
